import Record from "./base"

export default class Certification extends Record {
  constructor(...args) {
    super(...args)
    const [model, props] = args
  }
}
